import { render } from "./RetentionGuides.vue?vue&type=template&id=5b8ca273&scoped=true"
import script from "./RetentionGuides.vue?vue&type=script&lang=js"
export * from "./RetentionGuides.vue?vue&type=script&lang=js"

import "./RetentionGuides.vue?vue&type=style&index=0&id=5b8ca273&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8ca273"]])

export default __exports__